module.exports = __webpack_public_path__ + "img/ecpm_pin_space_new.949aa540.png";